// src/locales/ta/brands.js
export const brands = {
  // Page titles and descriptions
  title: "தயாரிப்பு பிராண்டுகள்",
  description: "சிறந்த அமைப்பு மற்றும் வாடிக்கையாளர் அங்கீகாரத்திற்காக தயாரிப்பு பிராண்டுகளை நிர்வகிக்கவும்",
  
  // Navigation
  addBrand: "பிராண்ட் சேர்க்கவும்",
  createNewBrand: "புதிய பிராண்ட் உருவாக்கவும்",
  editBrand: "பிராண்ட் திருத்தவும்",
  createFirstBrand: "முதல் பிராண்ட் உருவாக்கவும்",
  
  // Form Fields
  brandName: "பிராண்ட் பெயர்",
  brandNamePlaceholder: "பிராண்ட் பெயரை உள்ளிடவும் (எ.கா: நைக், சாம்சங், ஆப்பிள்)",
  brandDescription: "பிராண்ட் விவரம்",
  brandDescriptionPlaceholder: "பிராண்ட் பற்றிய சுருக்கமான விளக்கத்தை உள்ளிடவும்",
  brandLogo: "பிராண்ட் லோகோ",
  uploadLogo: "லோகோ பதிவேற்றவும்",
  chooseLogo: "லோகோ தேர்ந்தெடுக்கவும்",
  removeLogo: "லோகோ நீக்கவும்",
  logoHint: "ஏற்றுக்கொள்ளப்பட்ட வடிவங்கள்: JPG, PNG, WEBP. அதிகபட்ச அளவு: 2MB",
  
  // Table Headers and Content
  filteredResults: "{{total}} இல் {{count}} பிராண்டுகள்",
  totalBrands: "{{count}} பிராண்டுகள்",
  searchBrands: "பெயர் அல்லது விவரம் மூலம் பிராண்டுகளைத் தேடவும்...",
  
  // Selector specific
  selectBrand: "பிராண்ட் தேர்ந்தெடுக்கவும்",
  searchBrandsPlaceholder: "பிராண்டுகளைத் தேடவும்...",
  noBrandsFound: "உங்கள் தேடலுக்கு பொருந்தும் பிராண்டுகள் இல்லை",
  noBrandsAvailable: "பிராண்டுகள் கிடைக்கவில்லை",
  createBrand: "பிராண்ட் உருவாக்கவும்",
  
  // Validation Messages
  nameRequired: "பிராண்ட் பெயர் தேவை",
  nameMinLength: "பிராண்ட் பெயர் குறைந்தபட்சம் 2 எழுத்துக்களாக இருக்க வேண்டும்",
  nameMaxLength: "பிராண்ட் பெயர் 100 எழுத்துக்களை தாண்ட முடியாது",
  duplicateNameError: "இந்த பெயரில் ஏற்கனவே ஒரு பிராண்ட் உள்ளது",
  invalidLogoType: "தயவுசெய்து சரியான படக் கோப்பைப் பதிவேற்றவும் (JPG, PNG, WEBP)",
  logoTooLarge: "லோகோ கோப்பு அளவு 2MB க்கும் குறைவாக இருக்க வேண்டும்",
  
  // Actions
  createBrand: "பிராண்ட் உருவாக்கவும்",
  updateBrand: "பிராண்ட் புதுப்பிக்கவும்",
  savingBrand: "சேமிக்கிறது...",
  
  // Success/Error Messages
  brandCreatedSuccess: "'{{brandName}}' பிராண்ட் வெற்றிகரமாக உருவாக்கப்பட்டது!",
  brandUpdatedSuccess: "'{{brandName}}' பிராண்ட் வெற்றிகரமாக புதுப்பிக்கப்பட்டது!",
  brandDeletedSuccess: "'{{brandName}}' பிராண்ட் வெற்றிகரமாக நீக்கப்பட்டது.",
  failedToCreate: "பிராண்ட் உருவாக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
  failedToUpdate: "பிராண்ட் புதுப்பிக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
  failedToDelete: "பிராண்ட் நீக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
  failedToLoadBrand: "பிராண்ட் விவரங்களை ஏற்ற முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
  
  // Loading states
  loadingBrands: "பிராண்டுகள் ஏற்றப்படுகின்றன...",
  loadingBrandsDesc: "உங்கள் தயாரிப்பு பிராண்டுகளைப் பெறும் வரை காத்திருக்கவும்.",
  
  // Empty states
  noBrands: "இன்னும் பிராண்டுகள் இல்லை",
  noBrandsDesc: "உற்பத்தியாளர் அல்லது பிராண்ட் மூலம் உங்கள் தயாரிப்புகளை ஒழுங்கமைக்க உங்கள் முதல் தயாரிப்பு பிராண்டை உருவாக்கவும்.",
  noSearchResults: "பிராண்டுகள் கிடைக்கவில்லை",
  noSearchResultsDesc: "உங்கள் தேடல் சொற்களை சரிசெய்ய முயற்சிக்கவும் அல்லது அனைத்து பிராண்டுகளையும் பார்க்க வடிகட்டிகளை அழிக்கவும்.",
  
  // Confirmation dialogs
  confirmDelete: "'{{brandName}}' பிராண்டை நீக்குவது உறுதியா? இந்த செயலை மாற்ற முடியாது மற்றும் இந்த பிராண்டைப் பயன்படுத்தும் தயாரிப்புகளை பாதிக்கலாம்."
};